import axios from "axios";

export const SECTION_URL = "/Section";

/** Belli Bir Şube Listesini Elde Eder */
export function getSections(queryParams) {
  return axios.post(`${SECTION_URL}/GetSections`, queryParams);
}

/** Belli Bir Şube Listesini Sayfalama Olmadan Elde Eder */
export function getAllSections(queryParams) {
  return axios.post(`${SECTION_URL}/GetAllSections`, queryParams);
}

/** Yeni Bir Şubeyi Elde Eder */
export function getNewSection() {
  return axios.get(SECTION_URL);
}

/** Belli Bir Şubeyi Elde Eder */
export function getSection(id) {
  return axios.get(`${SECTION_URL}/${id}`);
}

/** Belli Bir Şubeyi Kaydeder */
export function saveSection(section) {
  return axios.post(SECTION_URL, section);
}

/** Belli Bir Şube Listesini Siler */
export function deleteSections(ids) {
  return axios.post(`${SECTION_URL}/Delete`, { ids });
}